export default __webpack_public_path__ + "static/media/show-icon.f6e40444.svg";